import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
// -- components --
import { CardType4Component } from 'app/modules/jc3/components/card-type-4/card-type-4.component';
@Component({
    selector: 'app-step-3',
    standalone: true,
    imports: [CardType4Component, CommonModule],
    templateUrl: './step-3.component.html',
    styleUrl: './step-3.component.scss',
})
export class Step3Component implements OnInit {
    @Input() cards: any[] = [];
    mappedCards: any[] = [];
    visibleCount: number = 6; // default for desktop
    increment: number = 6; // how many to add on "Show More"
    gaPrefix: string = 'building_learn_more_';

    ngOnInit(): void {
        this.setVisibleCount();
        this.updateMappedCards();
        // Optional: Update on window resize
        window.addEventListener('resize', () => this.setVisibleCount());
    }

    private updateMappedCards(): void {
        this.mappedCards = this.cards.map((card) => ({
            image: card.logo_url || card?.imagedesktop,
            title: card?.title,
            subtitle: card?.institution || card?.title,
            description: card.description,
            buttonText: card.cta,
            productUrl: card.url,
        }));
    }

    setVisibleCount() {
        const width = window.innerWidth;
        if (width < 1028) {
            // iPad Mini / iPad Air / Mobile
            this.visibleCount = 4;
            this.increment = 4;
        } else {
            // Desktop & iPad Pro
            this.visibleCount = 6;
            this.increment = 6;
        }
    }

    showMore() {
        this.visibleCount += this.increment;
    }

    openLink(url: string) {
        if (url) {
            window.open(url, '_blank');
        }
    }
}
